module.exports = __webpack_public_path__ + "img/ddwu_main1.d7571b9f.jpg";